module.exports = __webpack_public_path__ + "static/media/tree23.a33473b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/tree23.png
// module id = 132
// module chunks = 0